/**
 *  Mobile base player class that is inherited by all player types
 */

function MobileBasePlayer(config) {
  if (typeof config === "undefined") {
    return;
  }
  this.config = config;
  this.init();
}

/**
 * init() initializes the mobile swipe player.
 *   - sets instance variables
 *   - caches selectors
 *   - initializes hammer.js object
 */
// TODO: Migrate all base class code to this class from mobile_swipe.js
MobileBasePlayer.prototype.init = function () {
  // Set up the ClickGen tracker to monitor link impressions and clicks
  var ClickGenTracker = slideshare_object.utils.imports(
    "tracking.ClickGenTracker"
  );
  this.clickGenTracker = new ClickGenTracker();
  // Links are always enabled
  this.clickGenTracker.renderAllLinks = true;

  this.gaTracking("slideshow_type", this.config.slideshowType, undefined, true);

  // TODO: Make this a config value
  this.slideMargin = 7; // Base value
  this.sidebarWidthPercentage = 0.15;
  this.sidebarLoaded = false;
  this.maxSlideConsumed = 0;

  // Cache selectors
  this.$nav = $("#main-nav");
  this.$player = $(this.config.selectors.player);
  this.$container = this.$player.find(
    ">.player-container>.stage>.slide_container"
  );
  this.$slides = this.$container.find(".slide");
  this.$firstSlide = this.$slides.first();
  this.$stage = $(".mobile-stage");
  this.$sidebar = $(".sidebar");
  this.$title = $(".player-meta");
  this.$author = $(".slideshow-author");
  this.$svExtras = $(
    ".player-meta, #portrait-btns, .slideshow-author," +
      ".related, .footer, #mobile-nav"
  );
  this.$landscapeBtns = $("#landscape-btns");
  this.$actionBtns = $(".action-btns-container");
  this.totalSlides = this.$slides.length;
  this.slideWidth = 0;
  this.index = 0;
  this.ytubeSlides = {};
  this.ytubeAPILoaded = false;

  // Overlay for information display selector
  this.$overlay = $('.player-information-overlay');
  
  // Set max player height
  this.maxPlayerHeight = document.documentElement.clientHeight - 300;

  this.bindEvents();
};

MobileBasePlayer.prototype.bindEvents = function () {
  var self = this;

  $(window).on("load", function () {
    self.togglePlayerLayout();
    self.$stage.show(0);
  });

  $(window).on("orientationchange resize", function () {
    self.togglePlayerLayout();
  });
};

/**
 * gaTracking() fires a Google Analytics trackevent
 *
 * @param <String> action - Google Analytics action field
 * @param <String> label - Google Analytics label field
 * @param <String> value - Google Analytics value field
 * @param <Boolean> isNonInteractive - Google Analytics non_interaction field
 */
MobileBasePlayer.prototype.gaTracking = function (
  action,
  label,
  value,
  isNonInteractive
) {
  // Discard mobile preview tracking
  if (this.isMobilePreview()) {
    return;
  }
  var _gaq = window._gaq || [];
  label += "";
  _gaq.push([
    "_trackEvent",
    "mobile_swiping_slideview",
    action,
    label,
    value,
    !!isNonInteractive,
  ]);
};

/**
 * isMobilePreview() returns whether this player is being used by mobile preview
 */
MobileBasePlayer.prototype.isMobilePreview = function () {
  return window.location.search.indexOf("mobile_preview") !== -1;
};

/**
 * togglePlayerLayout() sets the appropriate player width/height
 */
MobileBasePlayer.prototype.togglePlayerLayout = function () {
  this.playerWidth = window.innerWidth - this.slideMargin * 4;
  this.playerHeight = Math.max(window.innerHeight, window.innerWidth) * 0.35;

  this.$player.width(this.playerWidth);
};

/**
 * initSlideRatio() loads the first slide and sets the slide ratio moving
 * forward.
 */
MobileBasePlayer.prototype.initSlideRatio = function () {
  if (this.meta) {
    var slideSize = this.meta.sizes["1"];
    if (slideSize) {
      this.origRatio = slideSize.width / slideSize.height;
    }
    this.origRatio = this.origRatio || 1;
  } else {
    var self = this;

    if (!this.origRatio) {
      // Set width of player based on image size. Store original image sizes
      var tempImage = new Image();
      tempImage.onload = function () {
        self.origRatio = this.width / this.height;
      };

      // TODO: change to config
      tempImage.src = $(".lazyload").first().data("original");
    }
  }

  this.togglePlayerLayout();
};

/**
 * Sets maximum height of the swiping player.
 */
 MobileBasePlayer.prototype.setMaxPlayerHeight =  function () {
   // We need to keep the download button visible. The easy way to do that is 100vh - 280px (roughly how much space description + header takes up)
   // but the viewport does change on iOS as the browser address bar shifts. So we're hardcoding this value as 640 - 280 = 360
   // 640px is the height of "small" phones like the Galaxy S5, Moto G4. Iphone 5/SE is smaller but 360 is a reasonable MAX height
   return 360;
 }

/**
 * setSlideWidths() calls the helper functions to calculate the new slide widths
 * and then sets the width of the slides and slide container to properly
 * implement drag/swipe. This function should be called on load and when the
 * device orientation changes.
 */
MobileBasePlayer.prototype.setSlideWidths = function () {
  this.updateDeviceOrientation();
  this.updateScreenDimensions();
  this.updateSlideDimensions();
  this.centerSlides();

  // iPhone/iPad and stock Android browsers can't handle fractional pixels
  this.slideWidth = /iPad|iPhone|Linux; U; Android/.test(navigator.userAgent)
    ? Math.ceil(this.slideWidth)
    : this.slideWidth;
  this.slideMarginRight = /iPad|iPhone|Linux; U; Android/.test(
    navigator.userAgent
  )
    ? Math.floor(this.slideMarginRight)
    : this.slideMarginRight;

  this.$container.css("margin-left", 2 * this.slideMarginLeft);
  this.$container.css("width", (this.slideMarginRight + this.slideWidth) * this.totalSlides);
  this.$slides.css("margin-right", this.slideMarginRight);
  
  var downloadButtonOnLastScreenOverlay = $(".download-cta-on-last-screen-overlay.active");
  if (downloadButtonOnLastScreenOverlay.length > 0) {
    downloadButtonOnLastScreenOverlay.css("right", this.slideMarginRight);
    downloadButtonOnLastScreenOverlay.css("margin-right", this.slideMarginRight);
    downloadButtonOnLastScreenOverlay.css("width", this.slideWidth);
    downloadButtonOnLastScreenOverlay.css("height",this.slideHeight);
  }

  var downloadCtaBelowReaderScreenPartialOverlay = $(".download-cta-below-reader.active");
  if (downloadCtaBelowReaderScreenPartialOverlay.length > 0) {
    downloadCtaBelowReaderScreenPartialOverlay.css("right", this.slideMarginRight);
    downloadCtaBelowReaderScreenPartialOverlay.css("margin-right", this.slideMarginRight);
    downloadCtaBelowReaderScreenPartialOverlay.css("height",this.slideHeight);
  }

  var guestLimitOverlay = $(".limit-overlay");
  if (guestLimitOverlay.length > 0 && window.innerWidth <= 928) {
    guestLimitOverlay.css("margin-left", 2 * this.slideMarginLeft);
    guestLimitOverlay.css("width", this.slideWidth);
    guestLimitOverlay.css("height",this.slideHeight);
  }
};

/**
 * updateDeviceOrientation() calculates and updates the device orientation of
 * the player based on window.orientation or viewport/screen size dimensions.
 */
MobileBasePlayer.prototype.updateDeviceOrientation = function () {
  var orientation;
  if (window.orientation) {
    orientation =
      Math.abs(window.orientation) === 90 ? "landscape" : "portrait";
  } else {
    var width = window.innerWidth || screen.width;
    var height = window.innerHeight || screen.height;
    orientation = width > height ? "landscape" : "portrait";
  }
  this.orientation = orientation;
};

/**
 * updateScreenDimensions() calculates and stores the true screen dimensions
 * for the mobile swipe player. Mobile support for calculating screen dimensions
 * differs across devices and browsers, and this function will always return the
 * true width and height of the player based on orientation and viewport sizes.
 */
MobileBasePlayer.prototype.updateScreenDimensions = function () {
  var screenWidth = 0,
    screenHeight = 0;

  // Sometimes x/y axis widths are not set properly. This function sets the
  // screen/viewport values properly
  var useScreenHeight =
    window.innerHeight === 0 ||
    (/iPhone|iPad/.test(navigator.userAgent) &&
      window.innerHeight >= screen.height);
  var height = useScreenHeight ? screen.height : window.innerHeight;
  var width = useScreenHeight ? screen.width : window.innerWidth;
  if (this.orientation === "portrait") {
    if (useScreenHeight) {
      screenHeight = screen.height > screen.width ? height : width;
      screenWidth = screen.width < screen.height ? width : height;
    } else {
      screenHeight = window.innerHeight > window.innerWidth ? height : width;
      screenWidth = window.innerWidth < window.innerHeight ? width : height;
    }
  } else {
    if (useScreenHeight) {
      screenHeight = screen.height < screen.width ? height : width;
      screenWidth = screen.width > screen.height ? width : height;
    } else {
      screenHeight = window.innerHeight < window.innerWidth ? height : width;
      screenWidth = window.innerWidth > window.innerHeight ? width : height;
    }
  }

  // Some mobile browsers require width/height of body to be set explicitly
  if (/iPhone|iPad/.test(navigator.userAgent)) {
    $("body").width(screenWidth);
    $("body").height(screenHeight);
  }

  // In case of desktop
  if (this.isMobilePreview()) {
    screenWidth = width;
    screenHeight = height + 1;
  }

  this.realScreenWidth = screenWidth;
  this.realScreenHeight = screenHeight;
};

/**
 * updateSlideDimensions() calculates the appropriate slide height, width, and
 * margins based on player orientation, player type, and slide ratio.
 *   - Portrait = full width minus space between slides (slide margins)
 *   - Infographic = full width minus space around slide (slide margins)
 *   - Landscape = maximum height while maintaining the ratio minus sidebar
 *     width and padding
 */
MobileBasePlayer.prototype.updateSlideDimensions = function () {
  var width = 0,
    height = 0,
    marginLeft = 0,
    marginRight = 0;

  width = this.realScreenWidth - this.slideMargin * 4;
  height = width / this.origRatio;

  /**
   * Limit height if either height > maxPlayerHeight, or if height > naturalHeight
   */
  var naturalHeight = this.$firstSlide.prop('naturalHeight');
  if (height > naturalHeight) {
    height = naturalHeight;
    width = height * this.origRatio;
    marginRight = (window.innerWidth - width) / 4;
  }
  else if (height > this.maxPlayerHeight - 20) {  // Subtract padding top & bottom
    height = this.maxPlayerHeight - 20;
    width = height * this.origRatio;
    marginRight = (window.innerWidth - width) / 4;
  }
  else {
    marginRight = this.slideMargin; // Base margin
  }

  this.slideWidth = width;
  this.slideHeight = height;
  this.slideMarginLeft = marginRight;
  this.slideMarginRight = marginRight;
};

// Dummy function to override in child classes
MobileBasePlayer.prototype.centerSlides = function () {};

/**
 * loadMetaJS() jsonp call to load meta.js file and handle contained data
 */
MobileBasePlayer.prototype.loadMetaJS = function () {
  var self = this;

  if (typeof slideshare_jsonp_meta_hook_trigger !== "function") {
    window.slideshare_jsonp_meta_hook_trigger = function () {};
  }

  $.ajax({
    type: "GET",
    url:
      this.config.image_bucket_location + "/meta.js?" + this.config.timestamp,
    async: false,
    cache: true,
    timeout: 10000,
    jsonpCallback: "slideshare_jsonp_meta_hook_trigger",
    contentType: "application/json",
    dataType: "jsonp",
    success: function (meta) {
      self.meta = meta;
      self.links = meta.links;
      self.linksLoaded = true;
      self.clickGenTracker.registerLinksMetadata(meta.links);
      self.initSlideRatio();
    },
  });
};

window.MobileBasePlayer = MobileBasePlayer;
export default MobileBasePlayer;